export default __webpack_public_path__ + "media/images/mailer/icon_person_add-a9759d23d1662ab87c2f255c8906107b.png";